import React, { Component } from "react";

import { ICloudFile } from "@formant/core/model/ICloudFile";

import { appStore, cloudFileStore } from "../../../stores";
import { Buttons } from "../../common/Buttons";
import {
    IMultiActionButtonAction,
    MultiActionButton,
} from "../../Observe/MultiActionButton";

export interface IActionsProps {
    cloudFile: ICloudFile;
}

export class Actions extends Component<IActionsProps> {
    public render() {
        const { onDelete, onDownload } = this;
        const actions: IMultiActionButtonAction[] = [
            {
                icon: "delete",
                label: "Remove",
                onSelect: onDelete,
            },
            {
                icon: "download",
                label: "Download",
                onSelect: onDownload,
            },
        ];
        return (
            <Buttons>
                <MultiActionButton actions={actions} />
            </Buttons>
        );
    }

    private onDelete = () => {
        const { cloudFile } = this.props;
        const { name } = cloudFile;
        appStore.setConfirm({
            title: "Delete file",
            message: `Delete file "${name}"?`,
            onOk: async () => {
                if (cloudFile.id) {
                    appStore.setSnackbar(`Deleting "${name}"...`);
                    await cloudFileStore.delete(cloudFile.id);
                    appStore.setSnackbar(`Cloud file "${name}" deleted`);
                }
            },
        });
    };

    private onDownload = async () => {
        const { cloudFile } = this.props;
        if (cloudFile.id) {
            window.location.href = await cloudFileStore.getUrl(cloudFile.id);
        }
    };
}
